import { useMutation } from '@tanstack/react-query';
import useSyncCache from '@/util/useSyncCache';
import { rateConversationMessage } from './api';
import { Rating } from './api.types';

export const useRateMessage = (conversationId?: string, messageId?: string) => {
  const invalidateQueries = useSyncCache();

  const { mutateAsync } = useMutation({
    mutationFn: (rating?: Rating) =>
      rateConversationMessage(conversationId!, messageId!, rating),
    onSuccess: () => invalidateQueries([['chatbot']]),
  });

  return mutateAsync;
};
